import React, { useEffect, useState } from "react"
import {
  Container,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import "../../assets/css/Staff/Staff.css"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import EducationView from "./ViewStaff/Education"
import PermissionView from "./ViewStaff/Permisions"
import InfoGif from "../../assets/images/GIF/question-mark.gif"
// common component
import Pagination from "components/Common/Pagination"
import Loader from "pages/Separate/Loader"
import axios from "axios"
import configure from "configure"
import moment from "moment"
import Swal from "sweetalert2"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import secureLocalStorage from "react-secure-storage"
import PersonalDetails from "./ViewStaff/PersonalDetails"
import ZithasCtc from "./ViewStaff/ZithasCtc"
import WorkExperience from "./ViewStaff/WorkExperience"
import Education from "./ViewStaff/Education"
import Documents from "./ViewStaff/Document"
import GenerateDoc from "./ViewStaff/GenerateDoc"
import ZithasCredential from "./ViewStaff/ZithasCredential"
import NewPagination from "components/Common/Newpagination"
import {
  fetchData,
  fetchNodeData,
  FetchNodePostData,
  FetchPostData,
} from "utils/common-fetchData"
import { staffColumns } from "utils/columns/Human Resource/humanResource"
import classnames from "classnames"
import {
  checkPermissionsByModule,
  getInitials,
  getPermissionsByModule,
  transformGeneralData,
} from "utils/common-helpers"
import { useSelector } from "react-redux"
import CompanyCommitment from "./ViewStaff/CompnayCommitment"
import Select from "react-select"
import { colourStyles } from "utils/common-options"
import AppointmentPreview from "./AppointmentPreview"


function formatStaffData(data = []) {

  return data;

  return ([
    ...(data.filter(d => d.approve_status == 1)),
    ...(data.filter(d => (d.approve_status == 0 || d.approve_status == 2))),
  ])
}

const StepNavigationStep = ({ step, currentStep, onStepChange }) => {
  const classes = classnames({
    active: step.id === currentStep,
    complete: currentStep > step.id,
  })
  return (
    <li
      className={classes}
      onClick={() => currentStep >= step.id && onStepChange(step.id)}
    >
      <div className="step">
        <i className={step.icon_class}></i>
      </div>
      <div className="caption hidden-xs hidden-sm">
        <span className="fs-5">{step.title}</span>
      </div>
    </li>
  )
}
const StepNavigation = ({ steps, currentStep, onStepChange }) => {
  return (
    <ol className="step-indicator">
      {steps.map(step => (
        <StepNavigationStep
          key={step.id}
          step={step}
          currentStep={currentStep}
          onStepChange={onStepChange}
        />
      ))}
    </ol>
  )
}
function TableContainer({ columns, data, setAccessDenied, setLoading }) {
  const [fixedHeader, setFixedHeader] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)
  document.addEventListener("scroll", () => {
    const scrollThreshold = window.innerHeight * 0.25
    if (window.scrollY > scrollThreshold) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })
  const navigate = useNavigate()
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )
  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])
  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedHeader(true)
    } else {
      setFixedHeader(false)
    }
  })
  const [name_modal, setNameModal] = useState(false)
  const [designation_modal, setDesignationModal] = useState(false)
  const [phone_modal, setPhoneModal] = useState(false)
  const [email_modal, setEmailModal] = useState(false)
  const [joining_modal, setJoiningModal] = useState(false)
  const [status_modal, setStatusModal] = useState(false)
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  // Center Modal
  function tog_center() {
    setNameModal(false)
    setDesignationModal(false)
    setPhoneModal(false)
    setEmailModal(false)
    removeBodyCss()
  }
  // Render the UI for your table
  const onAddPermission = async id => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", 66)
    try {
      await axios({
        method: "post",
        url: `${configure.apiUrl}/earth_permission`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(res => {
        const allEmail = data.map(item => item.email)
        if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
          navigate(`${configure.appUrl}addstaff`, {
            state: {
              allEmail: allEmail,
            },
          })
          // navigate(`${configure.appUrl}addstaff`)
        } else {
          setAccessDenied(true)
        }
        setLoading(false)
      })
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }
  const onAllClearLogin = async () => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", 66)
    try {
      await axios({
        method: "post",
        url: `${configure.apiUrl}/earth_permission`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(async res => {
        if (res.data.data.india[4] == 1 || res.data.data.uk[4] == 1) {
          try {
            const response = await axios({
              method: "get",
              url: `${configure.apiUrl}/allLoginClear`,
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            }).then(response => {
              Swal.fire({
                icon: "success",
                text: "All Login clear Successfully.",
              })
              setLoading(false)
            })
          } catch (err) {
            swal({
              icon: "error",
              text: "SomeThing Went Wrong",
            })
            setLoading(false)
          }
        } else {
          setLoading(false)
          setAccessDenied(true)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <div>
      {/* fixed buttons */}
      <div
        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        <Link
          onClick={() => onAddPermission()}
          className="btn btn-save fix-btn btn-label pe-0"
        >
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Staff</span>
        </Link>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red fix-btn btn-label pe-0"
          type="button"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col md={3}>
          <div>
            <select
              className=" form-select"
              style={{ width: "100px" }}
              value={pageSize}
              onChange={e => setPageSize(e.target.value)}
            >
              {[10, 25, 50, 100].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </div>
        </Col>
        <Col md={9} className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className=" form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div className="text-md-end">
            <Link
              onClick={() => onAddPermission()}
              // to={`${configure.appUrl}addstaff`}
              className=" btn text-white text-uppercase me-2 btn-save btn-label"
            >
              <i className="fas fa-plus me-2 icon-size label-icon"></i>Staff
            </Link>
            <Link
              onClick={() => onAllClearLogin()}
              className=" btn text-white text-uppercase btn-save btn-label"
            >
              <i className="fas fa-recycle me-2 icon-size label-icon"></i>All
              clear login
            </Link>
            <button
              onClick={() => navigate(-1)}
              className=" btn ms-md-2 btn-red btn-label"
              type="button"
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>
              CANCEL
            </button>
          </div>
        </Col>
      </Row>
      <Table className="table table-bordered mt-4 shadow" {...getTableProps()}>
        <thead
          className={`${fixedHeader && page.length >= 10 ? "fix-staffs-header" : ""
            } fix-staff-header`}
        >
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`t-col-${index + 1} ${column.className
                    } customShortIcon`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                  {column.isInfoIcon ? (
                    <a
                      onClick={() => {
                        if (column.Header == "Name") {
                          setNameModal(true)
                        } else if (column.Header == "Designation") {
                          setDesignationModal(true)
                        } else if (column.Header == "Phone no") {
                          setPhoneModal(true)
                        } else if (column.Header == "Email Id") {
                          setEmailModal(true)
                        } else if (column.Header == "Joining Date") {
                          setJoiningModal(true)
                        } else if (column.Header == "Status") {
                          setStatusModal(true)
                        }
                      }}
                    >
                      <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i>
                    </a>
                  ) : null}
                  {column.isShortIcon && (
                    <span
                      onClick={e => column.getSortByToggleProps().onClick(e)}
                      className="ms-2 cursor-pointer"
                    >
                      <i
                        title="Ascending"
                        className={`bi bi-arrow-up info-icon ${column.isSorted && !column.isSortedDesc
                          ? "text-dark"
                          : ""
                          }`}
                      ></i>
                      <i
                        title="Descending"
                        className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc
                          ? "text-dark"
                          : ""
                          }`}
                      ></i>
                    </span>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className={`fix-staff-header`} {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className={`row-hover ${row?.original?.approve_status == 0 && 'bg-light-blue2'} ${row?.original?.approve_status == 2 && 'bg-light-blue2'}`} {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      key={index}
                      className={`t-col-${index + 1}`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>
      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
          nextPage={nextPage}
        />
      </Row>
      {/* Name Modal */}
      <Modal
        isOpen={name_modal}
        toggle={() => {
          tog_center()
        }}
        className="bd-info-popup"
        centered
      >
        <div className="modal-header bd-head-info">
          <h5 className="modal-title mt-0">
            <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
            Staff Name Info
          </h5>
        </div>
        <div className="modal-body pb-0">
          <div className="d-flex">
            <div className="col-5 pr-30">
              <div>
                <img src={InfoGif} className="w-100" />
              </div>
            </div>
            <div className="mt-20 ">
              <div>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Cras
                  mattis consectetur purus sit amet fermentum. Cras justo odio,
                  dapibus ac facilisis in, egestas eget quam. Morbi leo risus,
                  porta ac consectetur ac, vestibulum at eros.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <div className="text-center mt-40">
                  <button
                    type="button"
                    className="btn btn-success "
                    onClick={() => setNameModal(false)}
                  >
                    I Understood
                    <i className="dripicons-thumbs-up pl-10"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* Designation Modal*/}
      <Modal
        isOpen={designation_modal}
        toggle={() => {
          tog_center()
        }}
        className="bd-info-popup"
        centered
      >
        <div className="modal-header bd-head-info">
          <h5 className="modal-title mt-0">
            <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
            Designation Info
          </h5>
        </div>
        <div className="modal-body pb-0">
          <div className="d-flex">
            <div className="col-5 pr-30">
              <div>
                <img src={InfoGif} className="w-100" />
              </div>
            </div>
            <div className="mt-20 ">
              <div>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Cras
                  mattis consectetur purus sit amet fermentum. Cras justo odio,
                  dapibus ac facilisis in, egestas eget quam. Morbi leo risus,
                  porta ac consectetur ac, vestibulum at eros.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <div className="text-center mt-40">
                  <button
                    type="button"
                    className="btn btn-success "
                    onClick={() => setDesignationModal(false)}
                  >
                    I Understood
                    <i className="dripicons-thumbs-up pl-10"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* Phone Number Modal*/}
      <Modal
        isOpen={phone_modal}
        toggle={() => {
          tog_center()
        }}
        className="bd-info-popup"
        centered
      >
        <div className="modal-header bd-head-info">
          <h5 className="modal-title mt-0">
            <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
            Contact Info
          </h5>
        </div>
        <div className="modal-body pb-0">
          <div className="d-flex">
            <div className="col-5 pr-30">
              <div>
                <img src={InfoGif} className="w-100" />
              </div>
            </div>
            <div className="mt-20 ">
              <div>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Cras
                  mattis consectetur purus sit amet fermentum. Cras justo odio,
                  dapibus ac facilisis in, egestas eget quam. Morbi leo risus,
                  porta ac consectetur ac, vestibulum at eros.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <div className="text-center mt-40">
                  <button
                    type="button"
                    className="btn btn-success "
                    onClick={() => setPhoneModal(false)}
                  >
                    I Understood
                    <i className="dripicons-thumbs-up pl-10"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* Email Modal*/}
      <Modal
        isOpen={email_modal}
        toggle={() => {
          tog_center()
        }}
        className="bd-info-popup"
        centered
      >
        <div className="modal-header bd-head-info">
          <h5 className="modal-title mt-0">
            <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
            Email Info
          </h5>
        </div>
        <div className="modal-body pb-0">
          <div className="d-flex">
            <div className="col-5 pr-30">
              <div>
                <img src={InfoGif} className="w-100" />
              </div>
            </div>
            <div className="mt-20 ">
              <div>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Cras
                  mattis consectetur purus sit amet fermentum. Cras justo odio,
                  dapibus ac facilisis in, egestas eget quam. Morbi leo risus,
                  porta ac consectetur ac, vestibulum at eros.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <div className="text-center mt-40">
                  <button
                    type="button"
                    className="btn btn-success "
                    onClick={() => setEmailModal(false)}
                  >
                    I Understood
                    <i className="dripicons-thumbs-up pl-10"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* Joining Date Modal*/}
      <Modal
        isOpen={joining_modal}
        toggle={() => {
          tog_center()
        }}
        className="bd-info-popup"
        centered
      >
        <div className="modal-header bd-head-info">
          <h5 className="modal-title mt-0">
            <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
            Joining Date Info
          </h5>
        </div>
        <div className="modal-body pb-0">
          <div className="d-flex">
            <div className="col-5 pr-30">
              <div>
                <img src={InfoGif} className="w-100" />
              </div>
            </div>
            <div className="mt-20 ">
              <div>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Cras
                  mattis consectetur purus sit amet fermentum. Cras justo odio,
                  dapibus ac facilisis in, egestas eget quam. Morbi leo risus,
                  porta ac consectetur ac, vestibulum at eros.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <div className="text-center mt-40">
                  <button
                    type="button"
                    className="btn btn-success "
                    onClick={() => setJoiningModal(false)}
                  >
                    I Understood
                    <i className="dripicons-thumbs-up pl-10"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* Status Modal*/}
      <Modal
        isOpen={status_modal}
        toggle={() => {
          tog_center()
        }}
        className="bd-info-popup"
        centered
      >
        <div className="modal-header bd-head-info">
          <h5 className="modal-title mt-0">
            <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
            Joining Date Info
          </h5>
        </div>
        <div className="modal-body pb-0">
          <div className="d-flex">
            <div className="col-5 pr-30">
              <div>
                <img src={InfoGif} className="w-100" />
              </div>
            </div>
            <div className="mt-20 ">
              <div>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Cras
                  mattis consectetur purus sit amet fermentum. Cras justo odio,
                  dapibus ac facilisis in, egestas eget quam. Morbi leo risus,
                  porta ac consectetur ac, vestibulum at eros.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <div className="text-center mt-40">
                  <button
                    type="button"
                    className="btn btn-success "
                    onClick={() => setStatusModal(false)}
                  >
                    I Understood
                    <i className="dripicons-thumbs-up pl-10"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

const Staff = () => {
  const [modal_Access, setAccessDenied] = useState(false)
  document.title = "Staff | Zithas Crm"
  const [modal_fullscreen, setmodal_fullscreen] = useState(false)
  const [previewModal, setPreviewModal] = useState(false)

  const [data, setDatas] = useState([])
  const [isLoading, setLoading] = useState(true)
  const [disableModal, setDisableModal] = useState(false)
  const [disableTransferData, setDisableTransferData] = useState({})
  const [reassignData, setReassignData] = useState({})
  const [staffDetails, setStaffDetails] = useState({})
  const toggleLoading = loading => {
    setLoading(loading)
  }
  const [selectedRows, setSelectedRows] = useState({
    contracts: [],
    projects: [],
    leads: [],
    tenders: [],
    bidding: [],
  })

  const toggleRowSelection = (type, id) => {
    setSelectedRows(prev => ({
      ...prev,
      [type]: prev[type].includes(id)
        ? prev[type].filter(x => x !== id)
        : [...prev[type], id],
    }))
    console.log("selected Rows: ", selectedRows)
  }

  const handleReassignChange = (section, key, itemData, selectedOption) => {
    if (!selectedOption) {
      // Clear assignment
      setReassignData(prev => {
        const newPrev = { ...prev }
        if (newPrev[section]) delete newPrev[section][key]
        return newPrev
      })
      return
    }

    setReassignData(prev => ({
      ...prev,
      [section]: {
        ...(prev[section] || {}),
        [key]: {
          ...itemData,
          assign: selectedOption.value,
        },
      },
    }))
  }

  // Bulk assign selected rows
  const handleAssignAll = (type, selectedOption) => {
    if (!selectedOption) return

    const rows = disableTransferData[type] || []
    rows.forEach((item, index) => {
      if (selectedRows[type].includes(item.id)) {
        handleReassignChange(type, index, item, selectedOption)
      }
    })

    setSelectedRows({
      contracts: [],
      projects: [],
      leads: [],
      tenders: [],
      bidding: [],
    })
  }

  // Helper to get current assigned option for a row
  const getAssignedOption = (section, index) => {
    const assignedId = reassignData?.[section]?.[index]?.assign
    if (!assignedId || !allDependency?.users) return null
    return allDependency.users.find(user => user.value === assignedId) || null
  }

  // For generalTasks (activity summary)
  const getActivityAssignedOption = key => {
    const assignedId = reassignData?.generalTasks?.[key]?.assign
    if (!assignedId || !allDependency?.users) return null
    return allDependency.users.find(user => user.value === assignedId) || null
  }
  document.addEventListener("keydown", e => {
    if (e.key === "Escape") setmodal_fullscreen(false)
  })
  const [staff_id, setStaffId] = useState("")
  const navigate = useNavigate()
  const role = useSelector(state => state?.Roles?.apiData)
  const transformDisableData = apiData => ({
    contracts:
      apiData.contracts?.map(c => ({
        id: c.id,
        title: c.contractTypes?.contract_type || "No Contract Type",
      })) || [],
    projects:
      apiData.projects?.map(p => ({
        id: p.id,
        name: p.project_name || "No Name",
      })) || [],
    leads:
      apiData.leads?.map(l => ({
        id: l.id,
        name: l.company || "No Company",
      })) || [],
    tenders:
      apiData.tenders?.map(t => ({
        id: t.id,
        name: t.name || "No Tender Name",
      })) || [],
    bidding:
      apiData.bidding?.map(b => ({
        id: b.id,
        name: b.name || "No Bidding Name",
        trash: b.trash,
        bidding_assignee: b.bidding_assignee,
        bidding_communicator: b.bidding_communicator,
      })) || [],
  })
  const onEditPermission = async ({ id }) => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", 66)
    try {
      await axios({
        method: "post",
        url: `${configure.apiUrl}/earth_permission`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(res => {
        if (res.data.data.india[4] == 1 || res.data.data.uk[4] == 1) {
          navigate(`${configure.appUrl}edit-staff/${id}`)
        } else {
          setAccessDenied(true)
        }
        setLoading(false)
      })
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }
  const onDeletePermission = async ({ id }) => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", 66)
    try {
      await axios({
        method: "post",
        url: `${configure.apiUrl}/earth_permission`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(res => {
        if (res.data.data.india[5] == 1 || res.data.data.uk[5] == 1) {
          Swal.fire({
            title: "Are you sure?",
            text: "You want to Delete this Staff !",
            icon: "warning",
            showCancelButton: true,
          }).then(async willDelete => {
            if (willDelete.isConfirmed) {
              setLoading(true)
              const formData = new FormData()
              formData.append("staff_id", id)
              try {
                const response = await axios({
                  method: "post",
                  url: `${configure.apiUrl}/destroy`,
                  data: formData,
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                  },
                }).then(response => {
                  Swal.fire({
                    icon: "success",
                    text: "Staff Deleted Successfully",
                  }).then(data => {
                    setDatas(formatStaffData(response?.data?.data))
                  })
                  setLoading(false)
                })
              } catch (err) {
                swal({
                  icon: "error",
                  text: "SomeThing Went Wrong",
                })
                setLoading(false)
              }
            }
          })
        } else {
          setAccessDenied(true)
        }
        setLoading(false)
      })
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }


  const onClearLogin = async ({ id }) => {
    const permission = await checkPermissionsByModule(role, 66, 4)
    if (permission) {
      try {
        const formDataEntries = {
          staff_id: id,
        }
        const response = await FetchPostData(
          toggleLoading,
          "login_clear",
          "",
          formDataEntries
        )
        if (response?.data?.success) {
          Swal.fire({
            icon: "success",
            text: "Staff Login clear Successfully",
          })
        }
      } catch (err) {
        swal({
          icon: "error",
          text: "SomeThing Went Wrong",
        })
      }
    } else {
      setLoading(false)
      setAccessDenied(true)
    }
  }
  const enableStaff = async (e, id, status) => {
    setLoading(true)
    const permission = await checkPermissionsByModule(role, 66, 4)
    setLoading(false)
    if (!permission) {
      setAccessDenied(true)
      e.target.checked = !e.target.checked
      return
    }
    Swal.fire({
      text: `Are you sure you want to enable this staff?`,
      icon: "warning",
      showCancelButton: true,
    }).then(async Active => {
      if (!Active.isConfirmed) {
        e.target.checked = !e.target.checked
        return
      }
      try {
        setLoading(true)
        const response = await FetchPostData(toggleLoading, "staffStatus", "", {
          staff_id: id,
          status,
        })
        if (response?.data?.success) {
          Swal.fire({
            text: "Staff Enabled Successfully",
            icon: "success",
          })
          setDatas(formatStaffData(response?.data?.data))
        }
      } catch (error) {
        console.log(error)
        e.target.checked = !e.target.checked
      }
      setLoading(false)
    })
  }

  const [allData, setAllData] = useState(null)
  const [allDependency, setAllDependency] = useState([])
  const [user_id, setUser_id] = useState(null)
  const statusChange = async (e, id, status, data) => {
    setAllData(data)
    setUser_id(id)
    fetchAllData()
    if (status === 0) {
      e.preventDefault()
      // revertCheckbox(id) // ✅ reset checkbox properly
      const response = await fetchNodeData(
        toggleLoading,
        `disableStaff/${id}`,
        secureLocalStorage.getItem("auth_token")
      )
      if (response.success || response.data.success) {
        const api = response.data || response.data.data
        setDisableTransferData({
          ...transformDisableData(api),
          groupedTasks: api.groupedTasks,
          ActivitySummary: transformActivityCounts(api),
        })
        setDisableModal(true)
      }
      return
    }
    enableStaff(e, id, status)
  }
  const transformActivityCounts = apiData => {
    if (!apiData.groupedTasks) return []
    const mapNames = {
      other: "Other",
      sales: "Sales",
      work: "Work",
      "human-resource": "Human Resource",
      finance: "Finance",
      tenders: "Tenders",
    }
    return Object.entries(apiData.groupedTasks).map(([key, value], index) => ({
      srNo: index + 1,
      label: `${mapNames[key] || key} - ${value.count ?? 0}`,
    }))
  }
  const onViewModal = (modal, staffId) => {
    setmodal_fullscreen(modal)
    setStaffId(staffId)
  }

  function openAppointmentModal(staff) {
    setPreviewModal(true)
    setStaffDetails(staff)
  }

  // table columns
  const columns = useMemo(
    () =>
      staffColumns(
        statusChange,
        onViewModal,
        onEditPermission,
        onClearLogin,
        onDeletePermission,
        openAppointmentModal
      ),
    []
  )
  const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const toggleVertical = tab => {
    setverticalActiveTab(tab)
  }
  const fetchStaff = async () => {
    const datas = await fetchData(
      toggleLoading,
      "staff",
      secureLocalStorage.getItem("auth_token")
    )
    setDatas(formatStaffData(datas?.data))
  }
  useEffect(() => {
    fetchStaff()
  }, [])
  const filterViewStaffData = useMemo(() => {
    return data?.find(item => item.id === staff_id)
  }, [staff_id, data])

  const location = useLocation()
  useEffect(() => {
    const staffId = localStorage.getItem("staffId")
    const roleId = localStorage.getItem("roleId")
    const cleanup = () => {
      if (staffId) {
        localStorage.removeItem("staffId")
      }
      if (roleId) {
        localStorage.removeItem("roleId")
      }
    }
    cleanup()
  }, [location])
  const [staffData, setStaffData] = useState({})

  const getStaffData = item => {
    setStaffData(item)
  }

  const onConfirmDisable = async () => {
    let finalData = { reassign: {} }
    let missing = []
    Object.entries(disableTransferData)
      .filter(
        ([key, list]) =>
          Array.isArray(list) &&
          key !== "ActivitySummary" &&
          key !== "groupedTasks"
      )
      .forEach(([section, list]) => {
        list.forEach((item, index) => {
          const assigned = reassignData?.[section]?.[index]?.assign
          if (!assigned) {
            missing.push(`${section} → ${item.name || item.title || item.id}`)
          }
        })
      })
    disableTransferData?.ActivitySummary?.forEach(summary => {
      const key = summary.label.split(" - ")[0].toLowerCase()
      const assigned = reassignData?.generalTasks?.[key]?.assign
      if (!assigned) {
        missing.push(`generalTasks → ${summary.label}`)
      }
    })
    if (missing.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Reassign Required",
        html: `
        <div style="text-align: left;">
          <b>You must reassign all items before disabling.</b><br/><br/>
          Missing:<br/>
          <ul style="text-align: left;">
            ${missing.map(m => `<li>${m}</li>`).join("")}
          </ul>
        </div>
      `,
      })
      return // STOP HERE
    }
    Object.entries(disableTransferData)
      .filter(
        ([key, list]) =>
          Array.isArray(list) &&
          key !== "ActivitySummary" &&
          key !== "groupedTasks"
      )
      .forEach(([section, list]) => {
        finalData.reassign[section] = {}
        list.forEach((item, index) => {
          finalData.reassign[section][index] = {
            ...item,
            assign: reassignData[section][index].assign,
          }
        })
      })
    // Build generalTasks
    finalData.reassign.generalTasks = {}
    disableTransferData.ActivitySummary?.forEach(summary => {
      const key = summary.label.split(" - ")[0].toLowerCase()
      finalData.reassign.generalTasks[key] = {
        ...disableTransferData.groupedTasks[key],
        assign: reassignData.generalTasks[key].assign,
      }
    })
    console.log("FINAL_REASSIGN_DATA →", finalData)
    const res = await FetchNodePostData(
      toggleLoading,
      "disableStaff",
      secureLocalStorage.getItem("aut_token"),
      { user_id: user_id, reassignData: finalData }
    )
    console.log("ressdvcsdvs: ", res)
    if (res.success || res?.data?.success) {
      Swal.fire({
        text: "Staff Disabled Successfully",
        icon: "success",
      }).then(() => {
        setReassignData({})
        setUser_id(null)
        fetchStaff()
        setDisableModal(false)
      })
    }
  }
  
  const revertCheckbox = id => {
    setDatas(prev =>
      prev.map(item =>
        item.id === id
          ? { ...item, login_access: item.login_access == 1 ? 0 : 1 }
          : item
      )
    )
  }
  const fetchAllData = async () => {
    const authToken = secureLocalStorage.getItem("auth_token")
    const datas = await axios({
      method: "get",
      url: `${configure.apiUrl}/generalData`,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${authToken}`,
      },
    })
    console.log("datas: ", datas?.data?.data)
    setAllDependency(transformGeneralData(datas?.data?.data))
  }
  const [disableStep, setDisableStep] = useState(1)
  const disableSteps = useMemo(() => {
    const steps = []
    console.log("disableTransferData: ", disableTransferData)
    if (disableTransferData.contracts?.length > 0)
      steps.push({ key: "contracts", title: "Contracts" })
    if (disableTransferData.projects?.length > 0)
      steps.push({ key: "projects", title: "Projects" })
    if (disableTransferData.leads?.length > 0)
      steps.push({ key: "leads", title: "Leads" })
    if (disableTransferData.tenders?.length > 0)
      steps.push({ key: "tenders", title: "Tenders" })
    if (disableTransferData.bidding?.length > 0)
      steps.push({ key: "bidding", title: "Bidding" })
    if (disableTransferData.ActivitySummary?.length > 0)
      steps.push({ key: "generalTasks", title: "My Activity Tasks" })
    return steps.map((s, index) => ({
      ...s,
      id: index + 1,
      icon_class: `bi bi-${index + 1}-circle-fill`,
    }))
  }, [disableTransferData])

  const modalUserOptions = allDependency?.users?.filter(user => {
    if (user?.value !== undefined) {
      return user.value !== allData?.id;
    }

    // normal user object
    return user.id !== allData?.id;
  });

  console.log("allDependency?.users : ", allDependency?.users);
  console.log("allData : ", allData);

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content" id="staff">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Staff"} />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data}
                      setAccessDenied={setAccessDenied}
                      setLoading={setLoading}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* View fullscreen Modal */}
      <Modal
        size="xl"
        isOpen={modal_fullscreen}
        toggle={() => {
          tog_fullscreen()
        }}
        className="modal-fullscreen"
      >
        <div className="modal-header mb-0">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ width: "100%" }}
          >
            <h5 className="col-6 modal-title mt-0">Staff Details</h5>
            <div className="col-6 mr-0 d-flex justify-content-end align-items-center">
              <img
                src={`${configure.imgUrl}${filterViewStaffData?.avatar}`}
                className="profileImg"
                alt="no img"
              />
              <p className="fw-bold mb-0 ms-2">{filterViewStaffData?.name}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={() => {
              setmodal_fullscreen(false)
              setverticalActiveTab("1")
            }}
            className="ms-4"
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <span
              aria-hidden="true"
              style={{ color: "#bf1e30", fontSize: "28px", lineHeight: "1px" }}
            >
              {" "}
              &times;{" "}
            </span>
          </button>
        </div>
        <div
          className="modal-body hide-bottom-scrollbar ps-3 pe-0 pt-0"
          id="staff-View"
        >
          <Row className="gx-4 justify-content-between">
            <Col md="2" className="side-tab py-3 h-100 bd-fixed-sidetab">
              <Nav pills className="flex-column">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "1",
                    })}
                    onClick={() => {
                      toggleVertical("1")
                    }}
                  >
                    Personal Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "2",
                    })}
                    onClick={() => {
                      toggleVertical("2")
                    }}
                  >
                    Zithas CTC
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "3",
                    })}
                    onClick={() => {
                      toggleVertical("3")
                    }}
                  >
                    Work Experience
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "4",
                    })}
                    onClick={() => {
                      toggleVertical("4")
                    }}
                  >
                    Education
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "5",
                    })}
                    onClick={() => {
                      toggleVertical("5")
                    }}
                  >
                    Documents
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "8",
                    })}
                    onClick={() => {
                      toggleVertical("8")
                    }}
                  >
                    Generate Documents
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "6",
                    })}
                    onClick={() => {
                      toggleVertical("6")
                    }}
                  >
                    Zithas Credential
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "9",
                    })}
                    onClick={() => {
                      toggleVertical("9")
                    }}
                  >
                    Company Commitment
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "7",
                    })}
                    onClick={() => {
                      toggleVertical("7")
                    }}
                  >
                    Permission
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md="10" className="bd-right-side-tab">
              <div className="p-4 h-100 pl-0">
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1">
                    <PersonalDetails
                      id={filterViewStaffData?.id}
                      verticalActiveTab={verticalActiveTab}
                      staffData={getStaffData}
                    />
                  </TabPane>
                  <TabPane tabId="2">
                    <ZithasCtc
                      id={filterViewStaffData?.id}
                      zithasCTC={staffData}
                    />
                  </TabPane>
                  <TabPane tabId="3">
                    <WorkExperience
                      id={filterViewStaffData?.id}
                      staffData={staffData}
                      verticalActiveTab={verticalActiveTab}
                    />
                  </TabPane>
                  <TabPane tabId="4">
                    <Education
                      id={filterViewStaffData?.id}
                      staffData={staffData}
                      verticalActiveTab={verticalActiveTab}
                    />
                  </TabPane>
                  <TabPane tabId="5">
                    <Documents
                      id={filterViewStaffData?.id}
                      verticalActiveTab={verticalActiveTab}
                    />
                  </TabPane>
                  <TabPane tabId="8">
                    <GenerateDoc
                      id={filterViewStaffData?.id}
                      verticalActiveTab={verticalActiveTab}
                    />
                  </TabPane>
                  <TabPane tabId="6">
                    <ZithasCredential id={filterViewStaffData?.id} />
                  </TabPane>
                  <TabPane tabId="7">
                    <PermissionView
                      id={filterViewStaffData?.id}
                      verticalActiveTab={verticalActiveTab}
                    />
                  </TabPane>
                  <TabPane tabId="9">
                    <CompanyCommitment
                      id={filterViewStaffData?.id}
                      staffData={staffData}
                    />
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>

      <Modal size="xl" isOpen={disableModal} className="">
        <div className="modal-header mb-0">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ width: "100%" }}
          >
            <h5 className="col-6 modal-title mt-0">Reassign Before Disable</h5>
            <div className="col-6 mr-0 d-flex justify-content-end align-items-center">
              {allData?.avatar ? (
                <img
                  src={`${configure.imgUrl}${allData?.avatar}`}
                  className="profileImg"
                  alt="no img"
                />
              ) : (
                <div className="defualt-img">
                  {getInitials(allData?.name || "Z")}
                </div>
              )}
              <p className="fw-bold mb-0 ms-2">{allData?.name}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={() => setDisableModal(false)}
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <span style={{ color: "#bf1e30", fontSize: "28px" }}>&times;</span>
          </button>
        </div>

        <div className="container-fluid mt-3">
          <div
            style={{
              top: 0,
              background: "#fff",
              zIndex: 100,
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <button
              className="btn btn-save btn-label"
              onClick={() => {
                if (disableStep < disableSteps.length) {
                  setDisableStep(prev => prev + 1)
                } else {
                  onConfirmDisable()
                }
              }}
            >
              {disableStep === disableSteps.length ? (
                <>
                  <i className="fas fa-save me-2 label-icon"></i>CONFIRM DISABLE
                </>
              ) : (
                <>
                  <i className="fas fa-arrow-right me-2 label-icon"></i>SAVE &
                  NEXT
                </>
              )}
            </button>
            {/* 
            <button
              type="button"
              onClick={() => setDisableModal(false)}
              className="btn btn-red btn-label"
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>
              CANCEL
            </button> */}
          </div>
          <StepNavigation
            steps={disableSteps}
            currentStep={disableStep}
            onStepChange={setDisableStep}
          />
        </div>

        <div className="modal-body">
          {(() => {
            const currentKey = disableSteps.find(s => s.id === disableStep)?.key

            if (currentKey === "contracts") {
              return (
                <>
                  <h5 className="fw-bold mt-3 mb-2 d-flex justify-content-between align-items-center">
                    <span>Contracts Assigned</span>
                    <Select
                      options={modalUserOptions}
                      placeholder="Assign selected to"
                      classNamePrefix="select"
                      styles={colourStyles}
                      onChange={opt => handleAssignAll("contracts", opt)}
                      isClearable
                      className="w-25"
                    />
                  </h5>
                  <div
                    style={{
                      maxHeight: "40vh",
                      overflowY: "auto",
                      paddingRight: "10px",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <Table bordered>
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: "5%" }}>
                            <input
                              type="checkbox"
                              checked={
                                disableTransferData.contracts?.length > 0 &&
                                selectedRows.contracts.length ===
                                disableTransferData.contracts.length
                              }
                              onClick={() =>
                                setSelectedRows(prev => ({
                                  ...prev,
                                  contracts:
                                    prev.contracts.length ===
                                      disableTransferData.contracts.length
                                      ? []
                                      : disableTransferData.contracts.map(
                                        x => x.id
                                      ),
                                }))
                              }
                            />
                            <span style={{ marginLeft: "5px" }}>ID</span>
                          </th>
                          <th>Contract Title</th>
                          <th>Reassign To</th>
                        </tr>
                      </thead>
                      <tbody>
                        {disableTransferData.contracts?.map((item, index) => (
                          <tr key={item.id}>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={selectedRows.contracts.includes(
                                  item.id
                                )}
                                onClick={() =>
                                  toggleRowSelection("contracts", item.id)
                                }
                              />
                            </td>
                            <td>{item.title}</td>
                            <td>
                              <Select
                                options={allDependency?.users}
                                classNamePrefix="select"
                                styles={colourStyles}
                                value={getAssignedOption("contracts", index)}
                                onClick={opt =>
                                  handleReassignChange(
                                    "contracts",
                                    index,
                                    item,
                                    opt
                                  )
                                }
                                isClearable
                                placeholder="Select Staff"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </>
              )
            }

            if (currentKey === "projects") {
              return (
                <>
                  <h5 className="fw-bold mt-3 mb-2 d-flex justify-content-between align-items-center">
                    <span>Projects Assigned</span>
                    <Select
                      options={modalUserOptions}
                      placeholder="Assign selected to"
                      classNamePrefix="select"
                      styles={colourStyles}
                      onChange={opt => handleAssignAll("projects", opt)}
                      isClearable
                      className="w-25"
                    />
                  </h5>
                  <div
                    style={{
                      maxHeight: "40vh",
                      overflowY: "auto",
                      paddingRight: "10px",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <Table bordered>
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: "7%" }}>
                            <input
                              type="checkbox"
                              checked={
                                disableTransferData.projects?.length > 0 &&
                                selectedRows.projects.length ===
                                disableTransferData.projects.length
                              }
                              onClick={() =>
                                setSelectedRows(prev => ({
                                  ...prev,
                                  projects:
                                    prev.projects.length ===
                                      disableTransferData.projects.length
                                      ? []
                                      : disableTransferData.projects.map(
                                        x => x.id
                                      ),
                                }))
                              }
                            />
                            <span style={{ marginLeft: "5px" }}>ID</span>
                          </th>
                          <th style={{ width: "60%" }}>Project Name</th>
                          <th style={{ width: "30%" }}>Reassign To</th>
                        </tr>
                      </thead>
                      <tbody>
                        {disableTransferData.projects?.map((item, index) => (
                          <tr key={item.id}>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={selectedRows.projects.includes(
                                  item.id
                                )}
                                onClick={() => {
                                  console.log("project selected")
                                  toggleRowSelection("projects", item.id)
                                }}
                              />
                              <span style={{ marginLeft: "5px" }}>
                                {item.id}
                              </span>
                            </td>
                            <td>{item.name}</td>
                            <td>
                              <Select
                                options={allDependency?.users}
                                classNamePrefix="select"
                                styles={colourStyles}
                                value={getAssignedOption("projects", index)}
                                onChange={opt =>
                                  handleReassignChange(
                                    "projects",
                                    index,
                                    item,
                                    opt
                                  )
                                }
                                isClearable
                                placeholder="Select Staff"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </>
              )
            }

            if (currentKey === "leads") {
              return (
                <>
                  <h5 className="fw-bold mt-3 mb-2 d-flex justify-content-between align-items-center">
                    <span>Leads Assigned</span>
                    <Select
                      options={modalUserOptions}
                      placeholder="Assign selected to"
                      classNamePrefix="select"
                      styles={colourStyles}
                      onChange={opt => handleAssignAll("leads", opt)}
                      isClearable
                      className="w-25"
                    />
                  </h5>

                  <div
                    style={{
                      maxHeight: "40vh",
                      overflowY: "auto",
                      paddingRight: "10px",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <Table bordered>
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: "7%" }}>
                            <input
                              type="checkbox"
                              checked={
                                disableTransferData.leads?.length > 0 &&
                                selectedRows.leads.length ===
                                disableTransferData.leads.length
                              }
                              onClick={() =>
                                setSelectedRows(prev => ({
                                  ...prev,
                                  leads:
                                    prev.leads.length ===
                                      disableTransferData.leads.length
                                      ? []
                                      : disableTransferData.leads.map(
                                        x => x.id
                                      ),
                                }))
                              }
                            />
                            <span style={{ marginLeft: "5px" }}>ID</span>
                          </th>
                          <th style={{ width: "60%" }}>Lead Name</th>
                          <th style={{ width: "30%" }}>Reassign To</th>
                        </tr>
                      </thead>

                      <tbody>
                        {disableTransferData.leads?.map((item, index) => (
                          <tr key={item.id}>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={selectedRows.leads.includes(item.id)}
                                onClick={() =>
                                  toggleRowSelection("leads", item.id)
                                }
                              />
                              <span className="ms-1">{item.id}</span>
                            </td>
                            <td>{item.name}</td>
                            <td>
                              <Select
                                options={allDependency?.users}
                                classNamePrefix="select"
                                styles={colourStyles}
                                value={getAssignedOption("leads", index)}
                                onChange={opt =>
                                  handleReassignChange(
                                    "leads",
                                    index,
                                    item,
                                    opt
                                  )
                                }
                                isClearable
                                placeholder="Select Staff"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </>
              )
            }

            if (currentKey === "tenders") {
              return (
                <>
                  <h5 className="fw-bold mt-3 mb-2 d-flex justify-content-between align-items-center">
                    <span>Tenders Assigned</span>
                    <Select
                      options={modalUserOptions}
                      placeholder="Assign selected to"
                      classNamePrefix="select"
                      styles={colourStyles}
                      onChange={opt => handleAssignAll("tenders", opt)}
                      isClearable
                      className="w-25"
                    />
                  </h5>

                  <div
                    style={{
                      maxHeight: "40vh",
                      overflowY: "auto",
                      paddingRight: "10px",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <Table bordered>
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: "7%" }}>
                            <input
                              type="checkbox"
                              checked={
                                disableTransferData.tenders?.length > 0 &&
                                selectedRows.tenders.length ===
                                disableTransferData.tenders.length
                              }
                              onClick={() =>
                                setSelectedRows(prev => ({
                                  ...prev,
                                  tenders:
                                    prev.tenders.length ===
                                      disableTransferData.tenders.length
                                      ? []
                                      : disableTransferData.tenders.map(
                                        x => x.id
                                      ),
                                }))
                              }
                            />
                            <span style={{ marginLeft: "5px" }}>ID</span>
                          </th>
                          <th style={{ width: "60%" }}>Tender Name</th>
                          <th style={{ width: "30%" }}>Reassign To</th>
                        </tr>
                      </thead>

                      <tbody>
                        {disableTransferData.tenders?.map((item, index) => (
                          <tr key={item.id}>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={selectedRows.tenders.includes(item.id)}
                                onClick={() =>
                                  toggleRowSelection("tenders", item.id)
                                }
                              />

                              <span className="ms-1">{item.id}</span>
                            </td>
                            <td>{item.name}</td>
                            <td>
                              <Select
                                options={allDependency?.users}
                                classNamePrefix="select"
                                styles={colourStyles}
                                value={getAssignedOption("tenders", index)}
                                onChange={opt =>
                                  handleReassignChange(
                                    "tenders",
                                    index,
                                    item,
                                    opt
                                  )
                                }
                                isClearable
                                placeholder="Select Staff"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </>
              )
            }

            if (currentKey === "bidding") {
              return (
                <>
                  <h5 className="fw-bold mt-3 mb-2 d-flex justify-content-between align-items-center">
                    <span>Bidding Assigned</span>
                    <Select
                      options={modalUserOptions}
                      placeholder="Assign selected to"
                      classNamePrefix="select"
                      styles={colourStyles}
                      onChange={opt => handleAssignAll("bidding", opt)}
                      isClearable
                      className="w-25"
                    />
                  </h5>

                  <div
                    style={{
                      maxHeight: "40vh",
                      overflowY: "auto",
                      paddingRight: "10px",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <Table bordered>
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: "7%" }}>
                            <input
                              type="checkbox"
                              checked={
                                disableTransferData.bidding?.length > 0 &&
                                selectedRows.bidding.length ===
                                disableTransferData.bidding.length
                              }
                              onClick={() =>
                                setSelectedRows(prev => ({
                                  ...prev,
                                  bidding:
                                    prev.bidding.length ===
                                      disableTransferData.bidding.length
                                      ? []
                                      : disableTransferData.bidding.map(
                                        x => x.id
                                      ),
                                }))
                              }
                            />
                            <span style={{ marginLeft: "5px" }}>ID</span>
                          </th>
                          <th style={{ width: "60%" }}>Bidding Name</th>
                          <th style={{ width: "30%" }}>Reassign To</th>
                        </tr>
                      </thead>

                      <tbody>
                        {disableTransferData.bidding?.map((item, index) => (
                          <tr key={item.id}>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={selectedRows.bidding.includes(item.id)}
                                onClick={() =>
                                  toggleRowSelection("bidding", item.id)
                                }
                              />

                              <span className="ms-1">{item.id}</span>
                            </td>
                            <td>{item.name}</td>
                            <td>
                              <Select
                                options={allDependency?.users}
                                classNamePrefix="select"
                                styles={colourStyles}
                                value={getAssignedOption("bidding", index)}
                                onChange={opt =>
                                  handleReassignChange(
                                    "bidding",
                                    index,
                                    item,
                                    opt
                                  )
                                }
                                isClearable
                                placeholder="Select Staff"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </>
              )
            }

            if (currentKey === "generalTasks") {
              return (
                <div>
                  <h5 className="fw-bold mt-2 mb-2">
                    My Activity Tasks Assigned
                  </h5>
                  <Table bordered className="mb-4">
                    <thead>
                      <tr>
                        <th style={{ width: "10%" }} className="text-center">Sr.No</th>
                        <th style={{ width: "45%" }}>Activity</th>
                        <th style={{ width: "45%" }}>Reassign To</th>
                      </tr>
                    </thead>
                    <tbody>
                      {disableTransferData.ActivitySummary?.map(row => {
                        const key = row.label
                          .split(" - ")[0]
                          .toLowerCase()
                          .replace(/\s+/g, "-")
                        return (
                          <tr key={row.srNo}>
                            <td className="text-center">{row.srNo}</td>
                            <td>{row.label}</td>
                            <td>
                              <Select
                                options={modalUserOptions}
                                placeholder="Select Staff"
                                classNamePrefix="select"
                                styles={colourStyles}
                                value={getActivityAssignedOption(key)}
                                onChange={opt =>
                                  handleReassignChange(
                                    "generalTasks",
                                    key,
                                    disableTransferData.groupedTasks[key],
                                    opt
                                  )
                                }
                                isClearable
                              />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </div>
              )
            }

            return null
          })()}
        </div>
      </Modal>
      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />


      <AppointmentPreview
        previewModal={previewModal}
        setPreviewModal={setPreviewModal}
        staff={staffDetails}
      />
    </React.Fragment>
  )
}
export default Staff
